import { Grid } from "@mui/material";
import React from "react";
import IncomingMailCard from "./IncomingMailCard.tsx/IncomingMailCard";
import { Props } from "./interfaces";

const ManageIncomingMailsList = ({
  items,
  handleNotifyParent,
  canUpload,
  canClassify,
  canRead,
  isOnlyRecipient,
}: Props) => {
  return (
    <Grid>
      {items.map((item, idx) => (
        <IncomingMailCard
          key={idx}
          incomingMail={item}
          handleNotifyParent={handleNotifyParent}
          canUpload={canUpload}
          canClassify={canClassify}
          canRead={canRead}
          isOnlyRecipient={isOnlyRecipient}
        />
      ))}
      {/* <IncomingMailCard/> */}
    </Grid>
  );
};

export default ManageIncomingMailsList;
